module.exports = __webpack_public_path__ + "media/img/pages/companies/chuv-ed7b9c7ec3d4eaf67040629494734e28.jpg";